import React from "react";
import { FiSearch, FiMessageSquare, FiInbox } from "react-icons/fi";
import { EmptyStateProps } from "../../types/messages.types";
import { UI_TEXT } from "../../constants/messages.constants";

/**
 * EmptyState Component
 * Displays various empty states with icon and text
 */
const EmptyState: React.FC<EmptyStateProps> = ({
  type,
  title,
  description,
}) => {
  const getIcon = () => {
    switch (type) {
      case "no-selection":
        return <FiMessageSquare size={40} className="text-neutral-400" />;
      case "no-messages":
        return <FiSearch size={32} className="text-neutral-400" />;
      case "no-results":
        return <FiInbox size={40} className="text-neutral-400" />;
      default:
        return <FiMessageSquare size={40} className="text-neutral-400" />;
    }
  };

  const getTitle = () => {
    if (title) return title;

    switch (type) {
      case "no-selection":
        return UI_TEXT.EMPTY_STATES.NO_SELECTION.title;
      case "no-messages":
        return UI_TEXT.EMPTY_STATES.NO_MESSAGES.title;
      case "no-results":
        return UI_TEXT.EMPTY_STATES.NO_RESULTS.title;
      default:
        return UI_TEXT.EMPTY_STATES.NO_SELECTION.title;
    }
  };

  const getDescription = () => {
    if (description) return description;

    switch (type) {
      case "no-selection":
        return UI_TEXT.EMPTY_STATES.NO_SELECTION.description;
      case "no-messages":
        return UI_TEXT.EMPTY_STATES.NO_MESSAGES.description;
      case "no-results":
        return UI_TEXT.EMPTY_STATES.NO_RESULTS.description;
      default:
        return UI_TEXT.EMPTY_STATES.NO_SELECTION.description;
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-full text-neutral-500 dark:text-neutral-400 p-8">
      <div className="w-20 h-20 mb-4 rounded-full bg-neutral-100 dark:bg-neutral-800 flex items-center justify-center">
        {getIcon()}
      </div>
      <h3 className="text-xl font-semibold text-neutral-900 dark:text-white mb-2">
        {getTitle()}
      </h3>
      <p className="text-sm text-center text-neutral-600 dark:text-neutral-400 max-w-sm">
        {getDescription()}
      </p>
    </div>
  );
};

export default EmptyState;
